document.addEventListener("turbolinks:load", function() {
  $("select[data-update-from-select]").change(function() {
    $.post($(this).data("update-from-select") + "?selection=" + $(this).val());
  })
})
